//DESKTOP | LAPTOP | TABLET
import React from "react";
import Hero from "./hero/hero";

const HeaderLarge = () => {
  return (
    <div className="relative overflow-hidden">
      <Hero />
    </div>
  );
};

export default HeaderLarge;
